import type { SVGProps } from 'react';
import { forwardRef, Ref } from 'react';

const SvgMail = (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
  <svg
    viewBox="0 0 22 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    role="img"
    aria-hidden={true}
    ref={ref}
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M4 7.80425V15H18V7.80425L11 12.1792L4 7.80425ZM15.5132 7H6.4868L11 9.82075L15.5132 7ZM2 5H20V17H2V5Z"
      fill="currentColor"
    />
  </svg>
);

/* eslint-disable import/no-default-export */
const ForwardRef = forwardRef(SvgMail);

export default ForwardRef;
